/**
 * Entry point for the React app.
 * Included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Initialize Firebase (side-effect import)
import "./firebase";

const elem = document.getElementById("root")!;
createRoot(elem).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
